@if (isPrintTable) {
  <div
    class="record-achievement-table"
    [innerHTML]="dynamicContentHtml() | safeHtml"></div>
}

@if (!isPrintTable) {
  <div class="record-achievement-table">
    @if (isPreview()) {
      <h3 class="preview-cms-watermark">PREVIEW</h3>
    }
    <table class="achievements-table">
      <tbody>
        <tr>
          <th rowspan="2">Target</th>
          <th rowspan="2">Unit of value</th>
          <th rowspan="2">Weighting</th>
          <th colspan="3">Target values</th>
          <th
            rowspan="100"
            class="space"></th>
          <th
            colspan="2"
            class="border-left">
            Target achievement
          </th>
        </tr>

        <tr>
          <td class="no-border-left">
            {{ (tableData()?.rows?.[0]?.firstTargetPercent | coinNumberView: false : false : false : true) ?? '-' }}%
          </td>
          <td>
            {{ (tableData()?.rows?.[0]?.secondTargetPercent | coinNumberView: false : false : false : false) ?? '-' }}%
          </td>
          <td>
            {{ (tableData()?.rows?.[0]?.thirdTargetPercent | coinNumberView: false : false : false : false) ?? '-' }}%
          </td>
          <td class="border-left">Actual Value</td>
          <td>in %</td>
        </tr>

        @for (achievement of tableData()?.rows; track achievement) {
          <tr class="data-row">
            <td>{{ achievement?.targetName }}</td>
            <td>{{ achievement?.metric }}</td>
            <td>{{ achievement?.weighting | coinNumberView: false : true }} %</td>
            <td>{{ achievement?.firstTargetValue | coinNumberView: false : true }}</td>
            <td>{{ achievement?.secondTargetValue | coinNumberView: false : true }}</td>
            <td>{{ achievement?.thirdTargetValue | coinNumberView: false : true }}</td>
            <td class="border-left">{{ achievement?.value | coinNumberView: false : true }}</td>
            <td>{{ achievement?.achieved | coinNumberView: false : true }} %</td>
          </tr>
        }

        <!-- IPP -->

        @if (hasIpp) {
          <tr class="grey higher">
            <td
              colspan="2"
              class="blank"></td>
            <td
              colspan="2"
              class="white-right-border">
              Unit target achievement in %
            </td>
            <td class="white text-center">{{ tableData()?.unitTargetAchievementBeforeSplit | percent: '1.2-2' }}</td>
            <td class="dark-grey text-center">{{ tableData()?.unitSplit | coinNumberView: false : true }} %</td>
            <td
              colspan="2"
              class="text-center border-left">
              {{ tableData()?.unitTargetAchievement | percent: '1.2-2' }}
              <div class="arrow-start"></div>
            </td>
          </tr>
          <tr class="grey higher">
            <td class="dark-grey bold border-top">{{ tableData()?.ippName }}</td>
            <td class="white text-center border-top">individual</td>
            <td
              colspan="2"
              class="white-right-border">
              Decision in PMP-EFA Round Table (Individual Performance Percentage - IPP)
            </td>
            <td class="white text-center"></td>
            <td class="dark-grey text-center split-between">
              {{ tableData()?.ippSplit | coinNumberView: false : true }}%
            </td>
            <td
              colspan="2"
              class="text-center border-left">
              {{ tableData()?.ippAchievementValue | percent: '1.2-2' }}
              <div
                class="arrow-add symbol"
                symbol="+"></div>
            </td>
          </tr>
        }

        <tr class="grey">
          <td
            colspan="2"
            class="blank"></td>
          <td colspan="4">Overall target achievement in %</td>
          <td
            colspan="2"
            class="text-center border-left">
            {{ overallTargetAchievement | percent: '1.2-2' }}
            @if (hasFactor && !hasIpp) {
              <div class="arrow-start"></div>
            }
            @if (hasFactor && hasIpp) {
              <div class="arrow"></div>
            }
            @if (hasIpp) {
              <div class="arrow-end"></div>
            }
          </td>
        </tr>

        <tr>
          <td
            colspan="100"
            class="space">
            @if (hasFactor) {
              <div class="arrow"></div>
            }
          </td>
        </tr>

        <!-- FACTOR -->
        @if (hasFactor) {
          <tr class="grey higher">
            <td
              colspan="2"
              class="dark-grey bold border-top">
              Individual Multiplier
            </td>
            <td
              colspan="3"
              class="white-right-border border-top"></td>
            <td
              colspan="1"
              class="white text-center border-top">
              between 0,8 - 1,2
            </td>
            <td
              colspan="2"
              class="text-center border-left border-top">
              {{ tableData()?.individualMultiplierValue || tableData()?.factorValue | coinNumberView: false : true }}
              <div
                class="arrow-add symbol"
                symbol="x"></div>
            </td>
          </tr>
          <tr class="grey higher">
            <td
              colspan="2"
              class="blank"></td>
            <td
              colspan="3"
              class="white-right-border">
              Total target achievement in %
            </td>
            <td
              colspan="1"
              class="white text-center">
              Target Achievement x Multiplier
            </td>
            <td
              colspan="2"
              class="text-center border-left">
              {{ tableData()?.totalTargetAchievement | percent: '1.2-2' }}
              <div class="arrow-end"></div>
            </td>
          </tr>
        }

        <tr>
          <td
            colspan="2"
            class="blank"></td>
          <td colspan="4">Target incentive amount in {{ currency() }} (100,00 %)</td>
          <td
            colspan="2"
            class="text-center border-left">
            {{
              (isLocalCurrency() ? tableData()?.targetIncentiveAmount : tableData().targetIncentiveAmountInEuro)
                | coinNumberView: false : true
            }}
          </td>
        </tr>

        <tr>
          <td
            colspan="100"
            class="space"></td>
        </tr>

        <!-- PAYOUT -->
        <tr class="blue">
          <td
            colspan="1"
            class="blank"></td>
          <td
            rowspan="2"
            class="blank bold">
            Results for the
            <br />
            review period
          </td>
          <td
            colspan="4"
            class="border-top">
            Target incentive amount in {{ currency() }} (prorated)
          </td>
          <td
            colspan="2"
            class="text-center border-left border-top">
            {{
              (isLocalCurrency() ? tableData()?.proratedTiaLocalCurrency : tableData()?.proratedTiaEuro)
                | coinNumberView: false : true
            }}
          </td>
        </tr>
        <tr class="blue higher">
          <td
            colspan="1"
            class="blank"></td>
          <td colspan="4">
            Payout amount in {{ currency() }}
            <sup>4</sup>
          </td>
          <td
            colspan="2"
            class="bold text-center border-left">
            {{
              (isLocalCurrency() ? tableData()?.payoutAmount : tableData()?.payoutAmountInEuro)
                | coinNumberView: false : true
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
}
